module["exports"] = [
  "Постач",
  "Торг",
  "Пром",
  "Трейд",
  "Збут"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/company/suffix.js
// module id = 1939
// module chunks = 0